import { cn } from "@/lib/utils";

interface ProgressBarProps {
  value: number;
  totalValue: number;
  small?: boolean;
}
const ProgressBar = ({
  value,
  totalValue,
  small = false,
}: ProgressBarProps) => {
  const percentage = (value / totalValue) * 100;
  return (
    <div
      className={cn(
        "relative min-w-12 w-full rounded-xl bg-white/20",
        small ? "h-2" : "h-4",
      )}
    >
      <div
        className="absolute h-full bg-progress-bar"
        style={{
          width: `${percentage}%`,
          borderRadius: percentage > 95 ? "0.75rem" : "0.75rem 0 0 0.75rem",
        }}
      />
    </div>
  );
};

export default ProgressBar;
